import React from 'react';

import FastImage from 'react-native-fast-image';

import { AspectRatio, ImageContentType, ImageType, Props } from './types';
import { getImageUrl } from './utils';

function NagraImage({
    source,
    style,
    resizeMode,
    contentId,
    contentType = ImageContentType.ANY,
    imageType = ImageType.ANY,
    priority = FastImage.priority.normal,
    cache = FastImage.cacheControl.immutable,
    aspect = AspectRatio.LANDSCAPE,
    height,
    width,
    onLoad,
    onError,
    testID,
}: Props) {
    const uri = getImageUrl({
        contentId,
        contentType,
        imageType,
        aspect,
        height,
        width,
    });

    return (
        <FastImage
            testID={testID}
            source={
                typeof source === 'number'
                    ? source
                    : { uri: source || uri, priority, cache }
            }
            style={style}
            resizeMode={resizeMode}
            onLoad={onLoad}
            onError={onError}
        />
    );
}

export default NagraImage;
